import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from '@environments/environment';
import { version } from '../package.json';

Sentry.init({
  dsn: environment.sentryDsn,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration({ enableInp: false }),
  ],
  tracesSampleRate: environment.sentryTracesSampleRate,
  replaysSessionSampleRate: environment.sentryReplaysSessionSampleRate,
  replaysOnErrorSampleRate: environment.sentryReplaysOnErrorSampleRate,
  enableLogs: environment.sentryEnableLogs,
  sendDefaultPii: environment.sentrySendDefaultPii,
  release: 'NoSe@' + version,
  beforeSend: event => {
    const has404Exception =
      event.exception?.values?.some(exc => {
        const msg = exc.value || exc.type || '';
        const lower = String(msg).toLowerCase();
        return (
          lower.includes('404') ||
          lower.includes('not found') ||
          (lower.includes('http failure response for') && lower.includes('404'))
        );
      }) ?? false;

    if (has404Exception) {
      return null;
    }

    if (
      event.extra?.['status'] === 404 ||
      event.tags?.['status'] === '404' ||
      event.contexts?.response?.status_code === 404
    ) {
      return null;
    }

    const httpStatus =
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (event.contexts as any)?.http?.status_code ??
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (event.request as any)?.status_code;
    if (httpStatus === 404) {
      return null;
    }

    return event;
  },
});

bootstrapApplication(App, appConfig).catch(err => console.error(err));
